import { UseFormReturn } from 'react-hook-form';
import { useLocalization } from '@ais-ui/locale-management';
import { MapFormValues } from './useMapForm';
import { HoverLabelToggle } from './HoverLabelToggle';

interface MethydHoverLabelsProps {
  form: UseFormReturn<MapFormValues>;
}

export const MethydHoverLabels = ({ form }: MethydHoverLabelsProps) => {
  const { messages } = useLocalization();

  const METHYD_HOVER_FIELDS = [
    { name: 'methyd_airRelatedSettings', label: messages.settingsMapMethydHoverAirLabel, description: messages.settingsMapMethydHoverAirDescription },
    { name: 'methyd_waterRelatedSettings', label: messages.settingsMapMethydHoverWaterLabel, description: messages.settingsMapMethydHoverWaterDescription },
    { name: 'methyd_lastOrigin', label: messages.settingsMapMethydHoverLastOriginLabel, description: messages.settingsMapMethydHoverLastOriginDescription },
    { name: 'methyd_location', label: messages.settingsMapMethydHoverLocationLabel, description: messages.settingsMapMethydHoverLocationDescription },
    { name: 'methyd_message', label: messages.settingsMapMethydHoverMessageLabel, description: messages.settingsMapMethydHoverMessageDescription },
    { name: 'methyd_metHydLatitude', label: messages.settingsMapMethydHoverLatitudeLabel, description: messages.settingsMapMethydHoverLatitudeDescription },
    { name: 'methyd_metHydLongitude', label: messages.settingsMapMethydHoverLongitudeLabel, description: messages.settingsMapMethydHoverLongitudeDescription },
    { name: 'methyd_metHydMmsi', label: messages.settingsMapMethydHoverMmsiLabel, description: messages.settingsMapMethydHoverMmsiDescription },
    { name: 'methyd_reportTimestamp', label: messages.settingsMapMethydHoverTimestampLabel, description: messages.settingsMapMethydHoverTimestampDescription },
    { name: 'methyd_siteId', label: messages.settingsMapMethydHoverSiteIdLabel, description: messages.settingsMapMethydHoverSiteIdDescription },
    { name: 'methyd_stationName', label: messages.settingsMapMethydHoverStationNameLabel, description: messages.settingsMapMethydHoverStationNameDescription },
    { name: 'methyd_dataTimeout', label: messages.settingsMapMethydHoverDataTimeoutLabel, description: messages.settingsMapMethydHoverDataTimeoutDescription },
    { name: 'methyd_owner', label: messages.settingsMapMethydHoverOwnerLabel, description: messages.settingsMapMethydHoverOwnerDescription },
  ] as const;

  return (
    <div className="grid grid-cols-2 gap-4">
      {METHYD_HOVER_FIELDS.map((field) => (
        <HoverLabelToggle
          key={field.name}
          form={form}
          name={field.name}
          label={field.label}
          description={field.description}
        />
      ))}
    </div>
  );
};
